import { set, omit } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import { createFetchManyHandler } from '../../../../helpers/reducerRoutineCrudHandler';
import {
  paginationState,
  resetPaginationState
} from '../../../../helpers/pagination';
import {
  fetchReservationPending,
  unlinkReservation
} from '../../sagas/routines';
import {
  clearReservationPending,
  reservationPendingOnChangePage,
  reservationPendingOnChangeOrder,
  reservationPendingRemoveItem
} from '../../actions/pending';

const initialState = {
  all: {},
  fetching: false,
  fetched: false,
  saving: false,
  saved: false,
  fetchingError: null,
  pagination: paginationState(),
  order: 'requestTime:asc'
};

const unlinkReservationHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, saving: true, saved: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set(`all.${response.id}`, response, state),
  [routine.FULFILL]: state => ({
    ...state,
    saving: false,
    saved: true
  })
});

const clearReservationPendingHandler = action => ({
  [action.toString()]: state => ({
    ...state,
    all: {},
    pagination: resetPaginationState(state.pagination)
  })
});

const reservationPendingOnChangePageHandler = action => ({
  [action.toString()]: (state, { payload: page }) =>
    set('pagination.currentPage', page, state)
});

const reservationPendingOnChangeOrderHandler = action => ({
  [action.toString()]: (state, { payload: order }) => set('order', order, state)
});

const reservationPendingRemoveItemHandler = action => ({
  [action.toString()]: (state, { payload: id }) => ({
    ...state,
    all: omit(id, state.all)
  })
});

export default createReducer(initialState, {
  ...createFetchManyHandler(fetchReservationPending),
  ...unlinkReservationHandler(unlinkReservation),
  ...clearReservationPendingHandler(clearReservationPending),
  ...reservationPendingOnChangePageHandler(reservationPendingOnChangePage),
  ...reservationPendingOnChangeOrderHandler(reservationPendingOnChangeOrder),
  ...reservationPendingRemoveItemHandler(reservationPendingRemoveItem)
});
